import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MainAxisAlignments } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import React, { forwardRef } from 'react';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import Emphasis from '@polestar/component-warehouse-react/tokens/emphasis/Emphasis';
import { createCSSTransition, MotionDurations, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
const Divider = forwardRef(({ spacing = Spacings.xLarge, mainAxisAlignment = MainAxisAlignments.center, ...props }, ref) => (React.createElement(StyledDivider, { ...props, ref: ref, spacing: spacing, mainAxisAlignment: mainAxisAlignment })));
Divider.displayName = 'Divider';
export default Divider;
const StyledDivider = styled('div', shouldNotForwardProps(true, 'spacing', 'mainAxisAlignment'))(({ theme, spacing, emphasis = Emphasis.medium, mainAxisAlignment = MainAxisAlignments.center }) => css([
    css `
        display: flex;
        position: relative;
        width: 100%;
        height: 1px;
        transition: ${createCSSTransition('margin', MotionEasings.ease, MotionDurations.fast)};
        background: ${theme.divider.emphasis[emphasis].backgroundColor};
      `,
    typeof spacing === 'string' &&
        mainAxisAlignment === MainAxisAlignments.start &&
        css `
          margin: 0 0 calc(${spacing} - 1px) 0;
        `,
    typeof spacing === 'string' &&
        mainAxisAlignment === MainAxisAlignments.center &&
        css `
          margin: calc(${spacing} * 0.5) 0 calc(${spacing} * 0.5 - 1px) 0;
        `,
    typeof spacing === 'string' &&
        mainAxisAlignment === MainAxisAlignments.end &&
        css `
          margin: calc(${spacing} - 1px) 0 0 0;
        `,
    typeof spacing !== 'string' &&
        spacing !== undefined &&
        css `
          ${responsiveStyles({ marginBlockStart: spacing, marginBlockEnd: spacing })}
        `,
]));
